// @ts-ignore
import React from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";
import FeatureGates from "@atlassian/feature-gate-js-client";
import UFOSegment from "@atlassian/wac-ufo-segment";

import {
    AiDeeplinkBanner,
    ImpossibleAloneBanner
} from "@/patterns/wpl/ad-banner/src";
import { GovTeamTourBanner } from "@/patterns/wpl/ad-banner/src/gov-fy24-team-tour-banner";

const bannerWrapperStyles = css({
    display: "flex",
    justifyContent: "center",
    marginBlockEnd: "56px",
    marginBlockStart: "16px",
    [media.only.sm]: {
        marginBlockStart: "-24px"
    },
    [media.above.md]: {
        marginBlockStart: "-48px"
    }
});

export const LiftedBanner = () => {
    const impossibleAloneGate: boolean = FeatureGates.checkGate(
        "wac-team-24-promotion-hero-and-banner"
    );

    const govGate: boolean = FeatureGates.checkGate(
        "wac-uip-gov-fy24-team-tour-lifted-bar"
    );
    const aiGate: boolean = FeatureGates.checkGate("gwp-457-ai-deeplink-gate");
    if (govGate) {
        return (
            <UFOSegment name="govteamtour-lifted-banner">
                <div css={bannerWrapperStyles}>
                    <GovTeamTourBanner />
                </div>
            </UFOSegment>
        );
    } else if (impossibleAloneGate) {
        return (
            <UFOSegment name="impossible-alone-lifted-banner">
                <div css={bannerWrapperStyles}>
                    <ImpossibleAloneBanner />
                </div>
            </UFOSegment>
        );
    } else if (aiGate) {
        return (
            <UFOSegment name="aideeplink-lifted-banner">
                <div css={bannerWrapperStyles}>
                    <AiDeeplinkBanner />
                </div>
            </UFOSegment>
        );
    }
    return null;
};
